import React from 'react';

import { StyledSpinner } from './spinner.styles';

import PulseSpinner from './pulse-spinner';

const Spinner = () => {
  return (
    <StyledSpinner>
      <PulseSpinner />
    </StyledSpinner>
  );
};

export default Spinner;
